import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const ImageCardWrapper = styled(Stack)`
  .image-card-item {
    height: 100%;

    > *,
    .image-card {
      height: 100%;
    }
  }
`;
